import { render, staticRenderFns } from "./EmergencyInformation.vue?vue&type=template&id=0899383a&scoped=true&"
import script from "./EmergencyInformation.vue?vue&type=script&lang=js&"
export * from "./EmergencyInformation.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyInformation.vue?vue&type=style&index=0&id=0899383a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0899383a",
  null
  
)

export default component.exports